<template>
    <div class="modal-out">
        <div class="modal">
            <div class="modal-header">
                <div class="title">添加</div>
                <button type="button" class="btn-close" @click="closeSelf">X</button>
            </div>
            <div class="modal-body">

                <el-form :model="addForm" :rules="rules" ref="addForm">

                  <el-row>
                    <el-col :span="12" class="item">
                        <el-form-item label="图标" required >
                            <el-upload class="upload-demo"
                                :action="uploadUrl"
                                list-type="picture-card"
                                :data='uploadData'
                                :show-file-list="false"
                                :on-success="handleImgSuccess"
                                style="width:100%;margin-top:40px">
                                <img v-if="addForm.icon" :src="addForm.icon" fit='cover' style="width: 100%;height: 100%;border-radius: 6px;">
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" class="item">
                      <el-row>
                        <el-col :span="24" class="item">
                          <el-form-item label="名称" required prop="name">
                            <el-input v-model="addForm.name" placeholder="请输入名称"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="24" class="item">
                          <el-form-item label="排序" required prop="sort">
                            <el-input v-model.number="addForm.sort" placeholder="请输入排序"></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>

                    </el-col>
                  </el-row>



                </el-form>

            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('addForm')">添加</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";


    export default {
        name: 'Add',
        props:['attributeList'],
        data() {
            return {
                loading: false,
                iconDialog: false,

                uploadUrl:this.$shopUrl+'Upload/Imgs',
                uploadData:{
                    staffCode:getStaffCode(),
                    timeStr:timeStr,
                    sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey)
                },

                addForm:{
                    timeStr:timeStr,
                    staffCode:getStaffCode(),
                    sign:'',
                    name:'',
                    icon:'',
                    sort:'',
                },
                rules:{
                    name:[
                        { required: true, message: '请输入名称', trigger: 'blur' },
                    ],
                    sort:[
                        { required: true, message: '请输入排序', trigger: 'blur' },
                        { type: 'number', message: '排序必须为数字值'}
                    ],

                },
            }
        },

        methods: {
            init(parentCode){
                //this.$refs.addForm.resetFields();

              console.log(parentCode);

              this.addForm.icon ='';
              this.addForm.name ='';
              this.addForm.sort =0;

            },
            closeSelf() {
                this.$emit("closeAdd");
            },


            handleImgSuccess(res, file) {
              console.log(file)
              this.addForm.icon = this.$imgUrl+res.data.path;
            },
            iconPreview() {
                this.iconDialog = true;
            },

          confirm(addForm){
            this.$refs[addForm].validate((valid) => {
              if(valid){
                if(!this.addForm.icon){
                  this.$message({type: 'warning', message: '请上传图标'});
                  return;
                }
                this.addSubmit();
              }else {
                console.log('error submit!!');
                return false;
              }
            })

          },
            addSubmit(){

                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }
                this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
                this.addForm.icon=this.addForm.icon.replace(this.$imgUrl,'')

              this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"TrainClass/Add",
                    data: this.addForm
                }).then((response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.$emit("closeAdd");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                    })
            },


        }
    }


</script>

<style lang="scss" scoped>

</style>
